module.exports = __webpack_public_path__ + "img/events.7353c389.svg";